import React, { useState } from 'react';
import { Star, ChevronLeft, ChevronRight, Quote } from 'lucide-react';
import './Testimonials.css';

const Testimonials = ({ data }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % data.reviews.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + data.reviews.length) % data.reviews.length);
  };

  const currentReview = data.reviews[currentIndex];

  return (
    <section className="testimonials" id="testimonials">
      <div className="testimonials-container">
        <div className="testimonials-header">
          <p className="section-subtitle">{data.subtitle}</p>
          <h2 className="section-title">{data.title}</h2>
        </div>

        <div className="testimonials-slider">
          <button className="slider-btn prev" onClick={prevTestimonial}>
            <ChevronLeft size={28} />
          </button>

          <div className="testimonial-card">
            <div className="quote-icon">
              <Quote size={40} />
            </div>
            <div className="stars">
              {[...Array(currentReview.rating)].map((_, i) => (
                <Star key={i} size={20} fill="var(--gold)" color="var(--gold)" />
              ))}
            </div>
            <p className="testimonial-text">{currentReview.text}</p>
            <div className="testimonial-author">
              <h4 className="author-name">{currentReview.name}</h4>
              <p className="author-wedding">{currentReview.wedding}</p>
            </div>
          </div>

          <button className="slider-btn next" onClick={nextTestimonial}>
            <ChevronRight size={28} />
          </button>
        </div>

        <div className="testimonials-dots">
          {data.reviews.map((_, index) => (
            <button
              key={index}
              className={`dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => setCurrentIndex(index)}
            ></button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
